var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import ReactDOM from 'react-dom';
import ChordPanel from '../views/ChordPanel';
import GoogleBlockly, { DropDownDiv, Field } from 'blockly/core';
import { getNoteName } from '../utils/Notes';
import { generateGraphDataFromChord } from '../utils/Chords';
var experiments = require('@cdo/apps/util/experiments');
var color = require('@cdo/apps/util/color');
var MAX_DISPLAY_NOTES = 3;
var FIELD_WIDTH = 51;
var FIELD_HEIGHT = 18;
var FIELD_PADDING = 2;
/**
 * A custom field that renders the chord selection UI, used in the
 * "play_chord" block. The UI is rendered by {@link ChordPanel}.
 */
var FieldChord = /** @class */ (function (_super) {
    __extends(FieldChord, _super);
    function FieldChord(options) {
        var _this = _super.call(this, options.currentValue) || this;
        _this.onValueChange = function (value) { return _this.setValue(value); };
        _this.options = options;
        _this.newDiv = null;
        _this.SERIALIZABLE = true;
        _this.CURSOR = 'default';
        _this.backgroundElement = null;
        return _this;
    }
    FieldChord.fromJson = function (options) {
        return new FieldChord(options);
    };
    FieldChord.prototype.saveState = function () {
        return this.getValue();
    };
    FieldChord.prototype.loadState = function (state) {
        this.setValue(state);
    };
    FieldChord.prototype.initView = function () {
        this.createBorderRect_();
        this.createTextElement_();
        if (this.borderRect_) {
            this.borderRect_.classList.add('blocklyDropdownRect');
        }
        this.backgroundElement =
            GoogleBlockly.utils.dom.createSvgElement('g', {
                transform: 'translate(1,1)',
            }, this.fieldGroup_);
        this.updateSize_();
    };
    FieldChord.prototype.applyColour = function () {
        var style = this.sourceBlock_.style;
        if (this.borderRect_) {
            this.borderRect_.setAttribute('stroke', style.colourTertiary);
            this.borderRect_.setAttribute('fill', 'transparent');
        }
        if (this.textElement_) {
            if (experiments.isEnabled('zelos')) {
                this.textElement_.style.fill = color.neutral_light;
            }
        }
    };
    FieldChord.prototype.getText = function () {
        var _a = this.getValue(), notes = _a.notes, instrument = _a.instrument;
        if (notes.length === 0) {
            return 'select notes';
        }
        return "".concat(instrument, " (").concat(this.getTruncatedNotes(notes), ")");
    };
    FieldChord.prototype.render_ = function () {
        var _this = this;
        if (this.backgroundElement) {
            this.backgroundElement.innerHTML = '';
        }
        GoogleBlockly.utils.dom.createSvgElement('rect', {
            fill: color.neutral_dark90,
            x: 1,
            y: 1,
            width: FIELD_WIDTH,
            height: FIELD_HEIGHT,
            rx: 3,
        }, this.backgroundElement);
        var graphNotes = generateGraphDataFromChord({
            chordEventValue: this.getValue(),
            width: FIELD_WIDTH,
            height: FIELD_HEIGHT,
            numOctaves: 3,
            startOctave: 4,
            padding: 2,
            noteHeightScale: 4,
        });
        graphNotes.forEach(function (graphNote) {
            GoogleBlockly.utils.dom.createSvgElement('rect', {
                fill: color.light_cyan,
                x: graphNote.x,
                y: graphNote.y,
                width: graphNote.width,
                height: graphNote.height,
                rx: 1,
            }, _this.backgroundElement);
        });
        this.renderContent();
    };
    FieldChord.prototype.updateSize_ = function () {
        var _a, _b;
        var width = FIELD_WIDTH + 2 * FIELD_PADDING;
        var height = FIELD_HEIGHT + 2 * FIELD_PADDING;
        (_a = this.borderRect_) === null || _a === void 0 ? void 0 : _a.setAttribute('width', '' + width);
        (_b = this.borderRect_) === null || _b === void 0 ? void 0 : _b.setAttribute('height', '' + height);
        this.size_.width = width;
        this.size_.height = height;
    };
    FieldChord.prototype.showEditor_ = function () {
        _super.prototype.showEditor_.call(this);
        var editor = this.createDropdown();
        DropDownDiv.getContentDiv().appendChild(editor);
        var style = this.sourceBlock_.style;
        DropDownDiv.setColour(style.colourPrimary, style.colourTertiary);
        DropDownDiv.showPositionedByField(this, this.disposeDropdown.bind(this));
    };
    FieldChord.prototype.createDropdown = function () {
        this.newDiv = document.createElement('div');
        this.renderContent();
        this.newDiv.style.color = color.neutral_light;
        this.newDiv.style.width = 'auto';
        this.newDiv.style.backgroundColor = color.dark_black;
        this.newDiv.style.padding = '5px';
        return this.newDiv;
    };
    FieldChord.prototype.renderContent = function () {
        if (!this.newDiv) {
            return;
        }
        ReactDOM.render(React.createElement(ChordPanel, {
            library: this.options.getLibrary(),
            initValue: this.getValue(),
            previewChord: this.options.previewChord,
            previewNote: this.options.previewNote,
            cancelPreviews: this.options.cancelPreviews,
            onChange: this.onValueChange,
        }), this.newDiv);
    };
    FieldChord.prototype.disposeDropdown = function () {
        this.newDiv = null;
    };
    FieldChord.prototype.getTruncatedNotes = function (notes) {
        var allNotes = notes
            .map(function (note) { return getNoteName(note); })
            .slice(0, MAX_DISPLAY_NOTES)
            .join(', ');
        return notes.length > MAX_DISPLAY_NOTES ? allNotes + '...' : allNotes;
    };
    return FieldChord;
}(Field));
export default FieldChord;
